import Button from '@components/atoms/button'
import { CompetitionTimer } from '@components/competitions/competition-timer'
import { useSessionContext } from '@contexts/session'
import { StudentProps } from '@lib/types/classroom'
import { FastlyImage } from '@components/common/image'
import RescheduleModalTitle from '@components/reschedule-course-class/reschedule-modal-title'
import { CALENDAR_IMAGE_PATH } from '@lib/constants/teacher-dashboard'
import { StudentDetailsCard } from '@components/reschedule-course-class/student-details'

type Props = {
  onOkClick: () => void
  studentDetails: StudentProps
  start: string
  lessonNumber: string | number
  lessonTitle: string
}

const RequestTeacherToInformStudent = ({
  onOkClick,
  studentDetails,
  start,
  lessonNumber,
  lessonTitle,
}: Props) => {
  const { name } = useSessionContext()
  return (
    <div className="flex flex-col space-y-5">
      <div className="flex items-center justify-center">
        <FastlyImage
          src={`${CALENDAR_IMAGE_PATH}calendar-reschedule.png`}
          width={100}
          height={100}
        />
      </div>
      <RescheduleModalTitle
        lessonNumber={lessonNumber}
        lessonTitle={lessonTitle}
      />
      <p>
        Hey {name},{' '}
        <span className="font-600">
          only <CompetitionTimer endTime={start} className="font-600" /> left
        </span>{' '}
        for the class to start. Class cancellation might degrade the
        student&apos;s experience!
      </p>
      <p className="text-xl font-600">
        Please call the {studentDetails.name} and inform first. After that you
        can proceed with class cancellation.
      </p>
      <StudentDetailsCard studentDetails={studentDetails} />
      <div className="flex justify-center">
        <Button onClick={onOkClick}>Ok, I will inform the student</Button>
      </div>
    </div>
  )
}

export default RequestTeacherToInformStudent
